package diana.soleil.design.iraniancanadienbazzar.core.model

/** Billing cadence for a subscription plan. */
enum class BillingInterval { Month, Year }

/**
 * "Mahaleh Pro" merchant subscription plans. `id` + price + interval MUST stay in sync with
 * `SUBSCRIPTION_PLANS` in `firebase/functions/index.js` (the Function is the source of truth for the
 * actual charge; [priceCents] here is display-only). Prices are placeholders until the owner revises.
 */
enum class SubscriptionPlan(val id: String, val priceCents: Long, val interval: BillingInterval) {
    ProMonthly("pro_monthly", 1999, BillingInterval.Month),
    ProAnnual("pro_annual", 19900, BillingInterval.Year);

    companion object {
        val all: List<SubscriptionPlan> = entries
    }
}
